export default __webpack_public_path__ + "c9bbcc80ec88c7630de1c8633e56ec76.jpg";